import { AlertTriangle, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Button } from "./Button";

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn("animate-pulse rounded-md bg-surface-2", className)} aria-hidden />;
}

export function PageSkeleton() {
  return (
    <div className="space-y-4" aria-busy="true" aria-label="Cargando">
      <Skeleton className="h-40 rounded-xl" />
      <div className="grid grid-cols-2 gap-3">
        <Skeleton className="h-24" />
        <Skeleton className="h-24" />
      </div>
      <Skeleton className="h-56" />
    </div>
  );
}

export function EmptyState({
  icon: Icon,
  title,
  message,
  action,
}: {
  icon: LucideIcon;
  title: string;
  message?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-12 text-center">
      <div className="grid size-14 place-items-center rounded-2xl bg-accent-soft text-accent">
        <Icon className="size-7" aria-hidden />
      </div>
      <div className="text-headline">{title}</div>
      {message && <p className="max-w-xs text-subhead text-muted">{message}</p>}
      {action}
    </div>
  );
}

export function ErrorState({
  error,
  onRetry,
  retryLabel = "Reintentar",
}: {
  error: unknown;
  onRetry?: () => void;
  retryLabel?: string;
}) {
  const message = error instanceof Error ? error.message : "No pudimos cargar la información.";
  return (
    <div role="alert" className="flex flex-col items-center gap-3 px-6 py-12 text-center">
      <AlertTriangle className="size-8 text-warning" aria-hidden />
      <p className="max-w-xs text-subhead text-muted">{message}</p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          {retryLabel}
        </Button>
      )}
    </div>
  );
}
